var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "color-secondary-6 font-14" }, [
          _vm._v(" Tipo de Lugar: ")
        ]),
        _c("span", { staticClass: "color-black font-16" }, [
          _vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.locationType)) + " ")
        ])
      ]),
      _vm.isSchoolPlace(_vm.data)
        ? _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v(" Región: ")
            ]),
            _c("span", { staticClass: "color-black font-16" }, [
              _vm._v(" " + _vm._s(_vm.data.regionName) + " ")
            ])
          ])
        : _vm._e(),
      _vm.isSchoolPlace(_vm.data)
        ? _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v(" Distrito: ")
            ]),
            _c("span", { staticClass: "color-black font-16" }, [
              _vm._v(" " + _vm._s(_vm.data.districtName) + " ")
            ])
          ])
        : _vm._e(),
      _vm.isSchoolPlace(_vm.data)
        ? _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v(" Escuela: ")
            ]),
            _c("span", { staticClass: "color-black font-16" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.data.schoolCode) +
                  " - " +
                  _vm._s(_vm.data.schoolName) +
                  " "
              )
            ])
          ])
        : _vm._e(),
      _vm.isMunicipalityVisible(_vm.data)
        ? _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v(" Municipio: ")
            ]),
            _c("span", { staticClass: "color-black font-16" }, [
              _vm._v(" " + _vm._s(_vm.data.municipalityName) + " ")
            ])
          ])
        : _vm._e(),
      _vm.isServicePlaceVisible(_vm.data)
        ? _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v(" Lugar de Servicio: ")
            ]),
            _c("span", { staticClass: "color-black font-16" }, [
              _vm._v(" " + _vm._s(_vm.data.locationName) + " ")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-3" }, [
      _c("em", { staticClass: "font-18 color-orange fa fa-info-circle mr-2" }),
      _c("span", { staticClass: "color-black font-16 font-weight-bold" }, [
        _vm._v(" Información de Lugar de Servicio ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }